const message = {
  ViewHelp: "View Help",
};

export default message;
